import React from 'react';
import { useEffect } from 'react';
import LoginBox from './LoginPage';
import './App.css';
import { insertDate } from './apiCommunicator';
import logo from './images/logo.png'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InfoPage from "./InfoPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginBox />} />
        <Route path="/success" element={<InfoPage />} />
        <Route path="/openai/login" element={<LoginBox />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
